module.exports = __webpack_public_path__ + "img/horizontal_3_2_7005.20a178f7.png";